export const mapTransport = item => ({
  id: item.id,
  name: `${item.name} ${item.number}`
})

export const mapObject = item => ({
  ...item,
  id: item.id,
  label: `${item.code} ${item.master ? item.master : ''} (${item.name})`
})
